import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

import { ref, onMounted } from 'vue';
import { getItemOptionsOfItem, type ItemOption } from '@/js/lib/api/item';
import ISelect from '@/js/components/molecules/ISelect.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ItemOptions',
  props: {
    itemId: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const cartButtonEl = document.querySelector('.cart-button') as HTMLDivElement;
const itemOptions = ref<ItemOption[]>([]);
const formatSelectItems = (itemOption: ItemOption) =>
  [
    itemOption.required ? [] : [{ value: '', label: '選択しない' }],
    ...itemOption.itemOptionVariants.map((variant) => [
      {
        value: variant.itemOptionVariantSlug,
        label: `${variant.name}${variant.price > 0 ? `（¥${variant.price.toLocaleString()}）` : ''}`,
      },
    ]),
  ].flat();
const itemOptionVariantSlugs = ref<(string | undefined)[]>([]);
const onSelectChange = () => {
  emit('update:modelValue', itemOptionVariantSlugs.value.filter(Boolean));
};
onMounted(async () => {
  const data = await getItemOptionsOfItem(props.itemId);
  itemOptions.value = data.itemOptions;
  itemOptionVariantSlugs.value = itemOptions.value.map((itemOption) => (itemOption.required ? undefined : ''));
  cartButtonEl.removeAttribute('style');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(_ctx.$style.optionList)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemOptions.value, (itemOption, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: itemOption.itemOptionSlug,
        class: _normalizeClass(_ctx.$style.optionItem)
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.$style.optionTitle)
        }, [
          _createTextVNode(_toDisplayString(itemOption.name), 1),
          (itemOption.required)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(_ctx.$style.required)
              }, "必須", 2))
            : _createCommentVNode("", true)
        ], 2),
        _cache[0] || (_cache[0] = _createTextVNode()),
        _createVNode(ISelect, {
          modelValue: itemOptionVariantSlugs.value[index],
          "onUpdate:modelValue": [($event: any) => ((itemOptionVariantSlugs.value[index]) = $event), onSelectChange],
          name: itemOption.name,
          items: formatSelectItems(itemOption),
          size: "small",
          rules: itemOption.required ? 'required' : '',
          placeholder: itemOption.required ? '選択してください' : '',
          class: _normalizeClass(_ctx.$style.optionSelect)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "items", "rules", "placeholder", "class"])
      ], 2))
    }), 128))
  ], 2))
}
}

})